import { makeModuleApiInfoSelector, makeModuleI18nSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { makeUploadInfoSelector } from "../MemberHelpdesk/selectors";
import { type MemberHelpdesk } from "../MemberHelpdesk/types";
import { closeTicket, createComment, getTicketData, rate } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  const uploadApiInfoSelector = makeUploadInfoSelector(true);
  const apiInfoSelector = makeModuleApiInfoSelector();
  const moduleI18nSelector = makeModuleI18nSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const i18n = moduleI18nSelector(state, props);
    return {
      ...props,
      canLeaveFeedback: localState.canLeaveFeedback,
      detail: localState.detail,
      surveyPageUrl: localState.permalink,
      isEditMode: state.isEditMode,
      status: localState.status,
      uploadApiInfo: uploadApiInfoSelector(state, props),
      error: localState.error ?? !!localState.obfuscatedEmail ? null : i18n.infoInvalidURL,
      isVisibleSecureModal: localState.isVisibleSecureModal,
      obfuscatedEmail: localState.obfuscatedEmail,
      apiInfo: apiInfoSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onSubmit: (data: MemberHelpdesk.View.NewComment) => dispatch(createComment(props, data)),
  onCloseTicket: () => dispatch(closeTicket(props)),
  onRate: (rating: number, ticketFeedbackQuestionId: string, permalink: string | null) =>
    dispatch(rate(props, rating, ticketFeedbackQuestionId, permalink)),
  onModalSubmit: (data) => dispatch(getTicketData(props, data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
